import React from 'react'

import PropTypes from 'prop-types'

import { Mutation } from 'react-apollo'
import { UPDATE_PASSWORD } from '../../../apollo/customer.graphql'
import { Formik, Form, Field } from 'formik'
import Fieldset from '../../Modifiers/Fieldset/Fieldset'
import { Password } from '../../Form/Password/Password'
import Error from '../../Error/Error'
import Button from '../../Button/Button'

import { object, string, ref } from 'yup'
import { passwordSchema } from '../../../utils/form-schemas'
import { dataByTypename } from '../../../utils/apollo-helpers'
import { toast } from 'react-toastify'

import './UpdatePasswordForm.css'

const validationSchema = object().shape({
  oldPassword: passwordSchema,
  newPassword: passwordSchema,
  confirmNewPassword: string()
    .oneOf([ref('newPassword'), null], 'Passwords do not match')
    .required('required')
})

const passwordInputConfigs = [
  {
    autoComplete: 'section-customer old-password',
    id: 'customer_old_password',
    label: 'Password',
    name: 'oldPassword'
  },
  {
    autoComplete: 'section-customer new-password',
    id: 'customer_new_password',
    label: 'New Password',
    name: 'newPassword'
  },
  {
    autoComplete: 'section-customer confirm-new-password',
    id: 'customer_confirm_new_password',
    label: 'Confirm New Password',
    name: 'confirmNewPassword'
  }
]

const initialFormValues = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: ''
}

const UpdatePasswordForm = ({ restaurantGuid = '' }) => {
  return (
    <Mutation mutation={UPDATE_PASSWORD}>
      {(updatePassword) => (
        <Formik
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting, resetForm, setError }) => {
            const input = {
              oldPassword: values.oldPassword,
              newPassword: values.newPassword,
              restaurantGuid
            }

            try {
              const result = await updatePassword({ variables: { input } })
              const { UpdatePasswordError } = dataByTypename(result.data.updatePassword)

              if (UpdatePasswordError) {
                setError(UpdatePasswordError)
              } else {
                toast('Password Updated Successfully!')
                resetForm(initialFormValues)
              }
            } catch (err) {
            } finally {
              setSubmitting(false)
            }
          }}
          enableReinitialize>
          {({error, isSubmitting, isValid, handleSubmit}) => (
            <Form>
              <Fieldset label='Reset Password' collapsable>
                {passwordInputConfigs.map(config => (
                  <Field key={config.id} component={Password} {...config} />
                ))}
                <div styleName='submitWrapper'>
                  {error && <Error error={error} />}
                  <Button
                    eventData={{
                      category: 'User Account',
                      action: 'Update Password'
                    }}
                    data-testid='button-submit-customer-password'
                    id={'SubmitCustomerPasswordButton'}
                    style='primary'
                    type='submit'
                    onClick={event => {
                      event.preventDefault()
                      handleSubmit()
                    }}
                    loading={isSubmitting}
                    disabled={!isValid}
                    responsive>
                      Update My Password
                  </Button>
                </div>
              </Fieldset>
            </Form>
          )}
        </Formik>
      )}
    </Mutation>
  )
}

UpdatePasswordForm.propTypes = {
  restaurantGuid: PropTypes.string
}

export default UpdatePasswordForm
